import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  const [reviews, setReviews] = useState([]);
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/admin/case-reviews"),
      api.get("/success-stories"),
    ])
      .then(([r, s]) => { setReviews(r.data); setStories(s.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const paid = reviews.filter((r) => r.payment_status === "paid").length;
  const pending = reviews.filter((r) => r.payment_status !== "paid").length;

  return (
    <div data-testid="admin-dashboard">
      <div className="eyebrow">Overview</div>
      <h1 className="font-display text-4xl mt-3 text-[#0F172A]">Dashboard</h1>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card testid="stat-total" label="Total submissions" value={loading ? "—" : reviews.length} />
        <Card testid="stat-paid" label="Paid reviews" value={loading ? "—" : paid} />
        <Card testid="stat-pending" label="Awaiting payment" value={loading ? "—" : pending} />
      </div>

      <div className="mt-16">
        <div className="flex items-baseline justify-between">
          <h2 className="font-display text-2xl text-[#0F172A]">Recent submissions</h2>
          <Link to="/admin/submissions" className="text-sm link-underline text-[#0F172A]" data-testid="view-all-submissions">View all →</Link>
        </div>
        <div className="mt-6 bg-white border border-[#0F172A]/10 divide-y divide-[#0F172A]/10">
          {reviews.slice(0, 5).map((r) => (
            <Link
              key={r.id}
              to={`/admin/submissions/${r.id}`}
              data-testid={`recent-${r.id}`}
              className="grid grid-cols-12 gap-4 p-5 hover:bg-[#F7F5F0] transition-colors"
            >
              <div className="col-span-4">
                <div className="text-sm font-medium text-[#0F172A]">{r.full_name}</div>
                <div className="text-xs text-[#4A4D50]">{r.email}</div>
              </div>
              <div className="col-span-3 text-sm text-[#4A4D50]">{r.visa_category}</div>
              <div className="col-span-3 text-sm text-[#4A4D50]">{r.field_of_expertise}</div>
              <div className="col-span-2 text-right">
                <span className={`text-xs px-3 py-1 border ${r.payment_status === "paid" ? "border-[#1A3626] text-[#1A3626]" : "border-[#C2A679] text-[#C2A679]"}`}>
                  {r.payment_status}
                </span>
              </div>
            </Link>
          ))}
          {!loading && reviews.length === 0 && (
            <div className="p-10 text-center text-[#4A4D50]">No submissions yet.</div>
          )}
        </div>
      </div>
    </div>
  );
}

function Card({ label, value, testid }) {
  return (
    <div data-testid={testid} className="bg-white border border-[#0F172A]/10 p-8">
      <div className="eyebrow">{label}</div>
      <div className="mt-4 font-display text-5xl text-[#0F172A]">{value}</div>
    </div>
  );
}
